<template>
  <v-card-text>
    <v-flex xs12 :class="['text-center', light? 'white--text' : 'primary--text']">{{loadingText}}...</v-flex>
    <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
    <v-flex xs12 class="mt-2 text-center">
      <v-progress-circular :size="60" :width="7" :color="loadingColor" indeterminate></v-progress-circular>
    </v-flex>
  </v-card-text>
</template>

<script>
export default {
  name: "CardLoadingTransparent",
  props: {
    loadingText: {
      type: String,
      default: () => "Carregando"
    },
    loadingColor: {
      type: String,
      default: () => "primary"
    },
    light:{
      type: Boolean,
      default: () => false
    }
  }
};
</script>

<style scoped>
</style>